import config from '../../config';

const _configShowtec = config.configAPISHOWNET(); // ou configAPISHOWTEC, depende do seu nome

class VeiculoService {
  async consultarDadosCadastrais(placa) {
    try {
      const base = (_configShowtec.URI_API || '').replace(/\/+$/, '');
      const token = _configShowtec.TOKEN;

      const p = (placa || '').toUpperCase().trim();
      const pLimpa = p.replace(/[^A-Z0-9]/g, '');

      const response = await fetch(`${base}/api/veiculos/consultarDadosCadastrais`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': token, // ✅ igual ao curl
        },
        body: JSON.stringify({ placa: pLimpa }),
      });

      const json = await response.json().catch(() => null);

      if (response.ok && json?.status === true) {
        return {
          anoModelo: json?.data?.anoModelo ?? null,
          cor: json?.data?.cor ?? null,
        };
      }

      return { error: true, message: json?.message || 'Placa não encontrada' };
    } catch (error) {
      console.log(error);
      return { error: true, message: 'Erro ao consultar dados da placa' };
    }
  }
}

export default new VeiculoService();
